// import { useEffect, useState } from "react";
// import publisher from "./publisherList.css";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import report from "../../assets/images/download-report.png";

// const AllPubList = () => {
//   const [allPubData, setAllPubData] = useState("");
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate();
//     const allPubList = async () => {
//       try {
//       const token = localStorage.getItem("token"); 
//       const allPubListRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllPublishers` , {
//         headers : {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//       });
//       if(allPubListRes.status === 200) {
//         setAllPubData(allPubListRes.data.data);
//       }else {
//         setMessage("No domains found.");
//       }
      
//     } catch (error){
//        setMessage("Error fetching domain list.");
//         if (error.response?.status === 401) {
//           console.error("Unauthorized! Token might be expired.");
//           localStorage.removeItem("token");
//           navigate("/");
//         } else {
//           console.error("Error fetching data:", error);
//         }
//     }
//   }
//   useEffect(()=>{
//     allPubList();
//   },[]);
//   return (
//     <section className="mainContainer">
//       <div className="container mt-4">
//         <h4>Publisher List</h4>
//         {message && <div className="alert alert-info">{message}</div>}
//       <table className="table table-striped table-hover table-bordered">
//                 <thead>
//             <tr>
//               <th scope="col">S.N </th>
//               <th scope="col">Account Name</th>
//               <th scope="col">Company Name</th>
//               <th scope="col"></th>
//             </tr>
//           </thead>
//           <tbody>
//             {
//               allPubData?.length > 0 ? (
//                 allPubData.map((pubList, pubListInd) =>(
//                   <tr key={pubListInd}>
//                     <td>{pubListInd + 1}</td>
//                     <td>{pubList?.account_name}</td>
//                     <td>{pubList?.company_name}</td>
//                     <td>
//                         <button
//                         className="btn btn-primary btn-md"
//                         onClick={() => navigate(`/edit-publisher/${pubList.account_id}`)}
//                       >
//                         Edit
//                       </button>
//                       &nbsp;
//                     <button
//                       className="btn btn-success btn-md"
//                       onClick={() => navigate(`/domain-list/${pubList.account_id}`)}
//                     >
//                       Domain List
//                     </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : 
//               <tr>
//                 <td colSpan="12" className="text-center">No data available</td>
//               </tr>
//             }
//           </tbody>
//       </table>
//       </div>
//     </section>
//   )
// };

// export default AllPubList;

import { useEffect, useState } from "react";
import "./publisherList.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FiEdit2, FiGlobe, FiUsers } from "react-icons/fi";

const AllPubList = () => {
  const [allPubData, setAllPubData] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const allPubList = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const allPubListRes = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllPublishers`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (allPubListRes.status === 200) {
        setAllPubData(allPubListRes.data.data || []);
      } else {
        setMessage("No publishers found.");
      }
    } catch (error) {
      setMessage("Error fetching publisher list.");

      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        localStorage.removeItem("userRole");
        localStorage.removeItem("account_id");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    allPubList();
  }, []);

  return (
    <section className="publisher-page">

      {/* Page Header */}
      <div className="publisher-header">
        <div className="publisher-title-section">
          <div className="publisher-title-icon">
            <FiUsers />
          </div>

          <div>
            <h2>Publisher List</h2>
            <p>Manage and view all registered publishers</p>
          </div>
        </div>

        <div className="publisher-count">
          <span>{allPubData.length}</span>
          <small>Publishers</small>
        </div>
      </div>

      {/* Message */}
      {message && (
        <div className="publisher-message">
          {message}
        </div>
      )}

      {/* Table Card */}
      <div className="publisher-card">

        <div className="publisher-card-header">
          <div>
            <h5>All Publishers</h5>
            <p>
              View publisher account and company information
            </p>
          </div>
        </div>

        {/* Responsive Table Wrapper */}
        <div className="publisher-table-wrapper">
          <table className="publisher-table">
            <thead>
              <tr>
                <th className="serial-column">S.N</th>
                <th>Account Name</th>
                <th>Company Name</th>
                <th className="actions-column">Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="publisher-loading">
                    Loading publishers...
                  </td>
                </tr>
              ) : allPubData.length > 0 ? (
                allPubData.map((pubList, pubListInd) => (
                  <tr key={pubList.account_id || pubListInd}>

                    <td className="serial-column">
                      {pubListInd + 1}
                    </td>

                    <td>
                      <div className="publisher-account">
                        <div className="publisher-avatar">
                          {pubList?.account_name
                            ?.charAt(0)
                            ?.toUpperCase() || "P"}
                        </div>

                        <span>
                          {pubList?.account_name || "-"}
                        </span>
                      </div>
                    </td>

                    <td>
                      <span className="company-name">
                        {pubList?.company_name || "-"}
                      </span>
                    </td>

                    <td className="actions-column">
                      <div className="publisher-actions">

                        <button
                          type="button"
                          className="publisher-btn edit-btn"
                          onClick={() =>
                            navigate(
                              `/edit-publisher/${pubList.account_id}`
                            )
                          }
                        >
                          <FiEdit2 />
                          <span>Edit</span>
                        </button>

                        <button
                          type="button"
                          className="publisher-btn domain-btn"
                          onClick={() =>
                            navigate(
                              `/domain-list/${pubList.account_id}`
                            )
                          }
                        >
                          <FiGlobe />
                          <span>Domain List</span>
                        </button>

                      </div>
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="publisher-empty">
                    <FiUsers size={28} />
                    <span>No publishers available</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </section>
  );
};

export default AllPubList;
